export function isFunction(func) {
    return typeof func === "function";
}
export function isUndefined(obj) {
    return typeof obj === "undefined";
}
export function isNumber(num) {
    return typeof num === "number";
}
export function isBoolean(bool) {
    return typeof bool === "boolean";
}
export function isString(str) {
    return typeof str === "string";
}
export function isObject(obj) {
    return obj !== null && typeof obj === "object";
}
export function isArray(array) {
    return $.isArray(array);
}
export function getTypeName(obj) {
    if (isUndefined(obj))
        return "undefined";
    if (obj == null)
        return "null";
    return getFunctionName(obj.constructor);
}
var functionNameRegex = new RegExp('function (.{1,})\\(');
export function getFunctionName(func) {
    if (func == null)
        return null;
    if ('name' in func)
        return func.name;
    var match = functionNameRegex.exec(func.toString());
    return (match && match.length > 1)
        ? match[1]
        : "";
}
//# sourceMappingURL=typeUtils.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/misc/typeUtils.js
// module id = 5
// module chunks = 1